import { IsObject } from '../../../helpers';
import { FINITE_STATE_OBSERVABLE_PRIVATE } from './privates';
import { ConstructClassWithPrivateMembers } from '../../../misc/helpers/ClassWithPrivateMembers';
import { InitObservableHook } from '../../../core/observable/hook/init';
import { HasFactoryWaterMark } from '../../../classes/class-helpers/factory';
import { NewFiniteStateObservableContext } from './context/implementation';
import { NormalizeFiniteStateObservableFinalStates, NormalizeFiniteStateObservableMode, NormalizeFiniteStateObservableModes } from './functions';
export function ConstructFiniteStateObservable(instance, context, create, options = {}) {
    ConstructClassWithPrivateMembers(instance, FINITE_STATE_OBSERVABLE_PRIVATE);
    const privates = instance[FINITE_STATE_OBSERVABLE_PRIVATE];
    privates.context = context;
    privates.values = [];
    if (IsObject(options)) {
        privates.finalStates = NormalizeFiniteStateObservableFinalStates(options.finalStates);
        privates.modes = NormalizeFiniteStateObservableModes(options.modes);
        privates.mode = NormalizeFiniteStateObservableMode(privates.modes, options.mode);
    }
    else {
        throw new TypeError(`Expected object or void as options.mode`);
    }
    privates.state = 'next';
    InitObservableHook(instance, privates, NewFiniteStateObservableContext, create);
}
export function IsFiniteStateObservable(value) {
    return IsObject(value)
        && value.hasOwnProperty(FINITE_STATE_OBSERVABLE_PRIVATE);
}
export const IS_COMPLETE_STATE_OBSERVABLE_CONSTRUCTOR = Symbol('is-from-observable-constructor');
export function IsFiniteStateObservableConstructor(value) {
    return (typeof value === 'function')
        && HasFactoryWaterMark(value, IS_COMPLETE_STATE_OBSERVABLE_CONSTRUCTOR);
}
//# sourceMappingURL=constructor.js.map